import { render, staticRenderFns } from "./AddressBookAddEdit.vue?vue&type=template&id=d30926da"
import script from "./AddressBookAddEdit.vue?vue&type=script&lang=js"
export * from "./AddressBookAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports